var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monthbutton"},[_c('MiniButton',_vm._g({},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }